module.exports = __webpack_public_path__ + "img/tab-dashboard-active.d4534c8b.svg";